import styled from "@emotion/styled";

const Subtitle = styled.h2`
  font-family: "DM Sans", sans-serif;
  font-size: 24px;
  margin: 10px 0 20px 0;
  max-width: 600px;

  @media screen and (min-width: 768px) {
    font-size: 40px;
  }
`;

export default Subtitle;
